import * as React from "react";
import { Modal, Card, Input } from "antd";

const { TextArea } = Input;

type Props = {
  status: boolean;
  onCancel: () => void;
  messageData: string;
};

export const PreviewModal: React.FC<Props> = ({ status, onCancel, messageData }) => {
  if (!status) return null;

  return (
    <Modal width={800} open={status} footer={null} onCancel={onCancel}>
      <Card title="Preview Message">
        <TextArea
          rows={7}
          placeholder={"Message"}
          maxLength={20000}
          size="small"
          status=""
          variant="outlined"
          disabled={false}
          readOnly={true}
          value={messageData}
          className="text-dark"
        />
      </Card>
    </Modal>
  );
};
